import React from 'react';

interface PlayingIconProp {
  style?: React.CSSProperties;
}

export const PlayingIcon: React.FC<PlayingIconProp> = ({ style }) => (
  <svg style={style} width="1.5em" height="1.5em" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
  </svg>
);
